import {
    createApi,
    fakeBaseQuery,
} from '@reduxjs/toolkit/query';
import {
    GladosServiceFactory,
    TariffSimOnlyParams,
    TariffSimOnlyResponse,
    TariffWithHardwareParams,
    TariffWithHardwareResponse,
} from '@vfde-sails/glados-v2';
import {
    RedplusTariff,
    RedTariff,
    YoungTariff,
} from '@vfde-sails/constants';
import { getQueryParam } from '@vfde-sails/utils';
import { isAxiosError } from 'axios';
import { RequestError } from '@vfde-sails/types';

const createRequestError = (error: unknown): RequestError => {
    if (isAxiosError(error)) {
        return {
            code: error.code,
            status: error.response?.status,
            message: error.message,
        };
    }

    return {
        message: error instanceof Error ? error.message : `${error}`,
    };
};

export const gladosApi = createApi({
    reducerPath: 'Glados',
    baseQuery: fakeBaseQuery<RequestError>(),
    endpoints: build => ({
        // TODO: I would like to have this `RedplusTariff | RedTariff | YoungTariff` as a generic instead
        // so each initiate/select method can specify which kind of tariff it expects
        getSimOnly: build.query<TariffSimOnlyResponse<RedplusTariff | RedTariff | YoungTariff>, TariffSimOnlyParams>({
            queryFn: async (params: TariffSimOnlyParams) => {
                const tariffService = GladosServiceFactory.getTariffService();



                try {
                    const response = await tariffService.getSimOnly<RedplusTariff | RedTariff | YoungTariff>('v1', params);

                    return { data: response.data };
                }
                catch (error) {
                    return {
                        error: createRequestError(error),
                    };
                }
            },
        }),
        getTariffWithHardware: build.query<TariffWithHardwareResponse<RedTariff | YoungTariff>, TariffWithHardwareParams>({
            queryFn: async (params: TariffWithHardwareParams) => {
                const tariffService = GladosServiceFactory.getTariffService();



                try {
                    const response = await tariffService.getTariffWithHardware<RedTariff | YoungTariff>('v1', params);

                    return { data: response.data };
                }
                catch (error) {
                    return {
                        error: createRequestError(error),
                    };
                }
            },
        }),
    }),
});

export const {
    getSimOnly,
    getTariffWithHardware,
} = gladosApi.endpoints;
